// extracted by css-extract-rspack-plugin
export default {"root":"uU9Nqz"};